<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "partLabel"
}
</script>

<style scoped>

</style>
